import React from 'react';
import { Box } from '@chakra-ui/react';
import TablaBeneficiarios from './TablaBeneficiarios';

const Beneficiarios: React.FC = () => {
  return (
    <Box px={{ base: 2, md: 4 }} pt={79} pb={4}>
      <TablaBeneficiarios />
    </Box>
  );
};

export default Beneficiarios;
